(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["subscriptionflow-product-buy-now"] = factory();
	else
		root["subscriptionflow-product-buy-now"] = factory();
})(this, function() {
return 